module.exports = __webpack_public_path__ + "static/img/app3@2x.5b0b73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/app3@2x.png
// module id = H9B4
// module chunks = 2